export default "__VITE_ASSET__BcdpeWb___"